import ResourceType from './resource-types';
import contentTypes from './activity-content-types';

export const activityComplete = (activity, contentType) => {
    if (activity && contentType === contentTypes.JUST_ATTACHMENT) {
        return activity.attachments && Object.keys(activity.attachments).length > 0;
    }
    if (activity && activity.value && contentType === contentTypes.SMALL_TEXT) {
        return true;
    }
    return activity && activity.value && activity.value.length >= 500;
};

export const isActivity = (item) => item.items
    .reduce((result, i) => result && (i.type === ResourceType.ACTIVITY), true);

export const donePercentage = (minicards, activities) => {
    const doneActivitiesCount = minicards
        .reduce((result, card) => result + mandatoryDoneCount(card, activities), 0);
    const overallMandatoryCount = minicards
        .reduce((result, card) => result + parseInt(mandatoryCount(card), 10), 0);
    return Math.trunc((doneActivitiesCount / overallMandatoryCount) * 100);
};

export const cardIsFinished = (card, activities) => {
    return parseInt(mandatoryCount(card), 10) === mandatoryDoneCount(card, activities);
};

export const neededDoneCount = (card, activities = {}) => allCardActivities(card)
    .slice(0, neededCount(card))
    .filter(act => activityComplete(activities[act.id], act.activityContentType))
    .length;

export const exchangedDoneCount = (card, activities) => {
    const maxExchanges = Math.min(exchangeCount(card), neededCount(card) - neededDoneCount(card, activities));
    return Math.min(doneActivitiesCount(card, activities), maxExchanges);
};

export const optionalDoneCount = (card, activities) => {
    const maxOptional = mandatoryCount(card) - neededCount(card);
    const optional = doneActivitiesCount(card, activities) - neededDoneCount(card, activities) - exchangedDoneCount(card, activities);
    return Math.min(optional, maxOptional);
};

export const mandatoryDoneCount = (card, activities) => {
    const needed = neededDoneCount(card, activities);
    const exchanged = exchangedDoneCount(card, activities);
    const optional = optionalDoneCount(card, activities);
    return needed + exchanged + optional;
};

const doneActivitiesCount = (card, activities = {}) => allCardActivities(card)
    .filter(item => activityComplete(activities[item.id], item.activityContentType))
    .length;

const allCardActivities = card => (card.items || [])
    .reduce((result, item) => result.concat(item.items.map(i => ({ ...i, id: i.id || item.title }))), [])
    .filter(item => item.type === ResourceType.ACTIVITY);

const mandatoryCount = card => card.mandatoryCount || allCardActivities(card).length;
const neededCount = card => card.neededCount || 0;
const exchangeCount = card => card.exchangeCount || 0;



// WEBPACK FOOTER //
// ./src/utils/tcc-utils.js